import { CommonModule } from "@angular/common";
import { Component, OnInit, forwardRef } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NavController, NavParams, ModalController, IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { ImagePipe } from "src/app/pipes/image/image";
import { NomenclaturaPipe } from "src/app/pipes/nomenclatura/nomenclatura";
import { GrupoProvider } from "src/app/services/grupo/grupo";
@Component({
  selector: "app-meus-grupos-ministerios-detalhes",
  templateUrl: "./meus-grupos-ministerios-detalhes.page.html",
  styleUrls: ["./meus-grupos-ministerios-detalhes.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, ImagePipe, TranslateModule, NomenclaturaPipe, SemRegistroComponent],
})
export class MeusGruposMinisteriosDetalhesPage implements OnInit {
  tipo: any;
  idGrupo: string;
  grupoNome: any;
  hierarquiaList: any = [];
  i: number = 0;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public grupoProvider: GrupoProvider,
    public modalCtrl: ModalController
  ) {
    this.tipo = this.navParams.get("tipo");
    this.idGrupo = this.navParams.get("idGrupo");
    this.grupoNome = this.navParams.get("grupoNome");

    this.grupoProvider.getHierarquia(this.idGrupo, this.tipo).subscribe((data) => {
      this.hierarquiaList = data;
    });
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  get hasHierarquiaGrupoFuncao(): boolean {
    return this.hierarquiaList?.some((h: { funcoes: any[]; }) => h.funcoes?.some((f) => f.hierarquiaGrupoFuncao?.pessoa));
  }
}
